import "./license.css";

export const initRights = () => {
	const getEmbeddingWrap = (ele:HTMLElement):HTMLElement | null => {
		if (!ele) { return null;}
		if (ele.tagName === "FIGURE" && ele.getAttribute("figure-type") === "embedding") {
			return ele;
		}
		if (ele.parentElement) {
			return getEmbeddingWrap(ele.parentElement);
		}
		return null;
	};

	const embedLinker = (licenseEle:HTMLElement, licenseContent:HTMLElement):boolean => {
		if (!licenseEle || !licenseContent) { return false;}
		const parentWrap = getEmbeddingWrap(licenseEle);
		if (!parentWrap) { return false;}
		const link = parentWrap.querySelector<HTMLAnchorElement>("a.embedding-link");
		if (!link) { return false;}
		const licenseLink = document.createElement("a");
		licenseLink.href = link.href;
		licenseLink.innerText = link.href;
		licenseLink.target = "_blank";
		licenseContent.append(licenseLink);
		return true;
	};

	document.querySelectorAll("details.license").forEach(details => {
		const summary = details.querySelector("summary");
		if(summary === null){return;}
		const licenseContent = details.querySelector("license-content");
		if((licenseContent === null) || (licenseContent.innerHTML.trim().length === 0)){
			const embedLinked = embedLinker(summary as HTMLElement, licenseContent as HTMLElement);
			if (!embedLinked) {
				summary.classList.add("missing-attribution");
			}
		}
		details.setAttribute("open","");
		summary.addEventListener('click',(e) => {
			e.preventDefault();
			e.stopPropagation();
			details.classList.toggle("active");
		});
		licenseContent?.addEventListener("click", (e) => {
			// Keep figure/lightbox handlers from calling preventDefault on link clicks.
			e.stopPropagation();
		});
	});
};
setTimeout(initRights, 0);
